export default {
	data() {
		return {
			status: 1,
		};
	},
	methods: {
		toogleBody(target, time = 300) {
			if (this.status == 0) {
				$(target).show(time);
				this.status = 1;
			} else {
				$(target).hide(time);
				this.status = 0;
			}
		},
	},
};



// WEBPACK FOOTER //
// ./src/components/order-of-service/components/ModeAgroup/js/ToogleFunction.mixin.js